import React from 'react';
import {curry} from 'ramda';
import {FrameRate} from '@accurate-player/accurate-player-core';

import AudioTrackContainer from './AudioTrack/AudioTrackContainer';
import {
    AudioChannelClick,
    AudioTrackClick,
    AudioTrackData,
} from './AudioTracksTypes';

export interface AudioTracksProps {
    audioTracks: AudioTrackData[];
    onlyMonoAudioAvailable: boolean;
    frameRate: FrameRate;
    onAudioTrackClick: AudioTrackClick;
    onAudioChannelClick: AudioChannelClick;
}

type MapAudioTrackProps = {
    onlyMonoAudioAvailable: boolean,
    frameRate: FrameRate,
    onAudioChannelClick: AudioChannelClick,
    onAudioTrackClick: AudioTrackClick,
}

const mapAudioTrack = curry((props: MapAudioTrackProps, trackData: AudioTrackData) => {
    const {
        onlyMonoAudioAvailable,
        frameRate,
        onAudioChannelClick,
        onAudioTrackClick,
    } = props;
    const {src} = trackData;
    
    return (
        <AudioTrackContainer
            key={src}
            onlyMonoAudioAvailable={onlyMonoAudioAvailable}
            trackData={trackData}
            frameRate={frameRate}
            onAudioTrackClick={onAudioTrackClick}
            onAudioChannelClick={onAudioChannelClick}
        />
    );
});

export const getAudioTracks = (props: AudioTracksProps) => {
    const {
        audioTracks,
        onlyMonoAudioAvailable,
        frameRate,
        onAudioTrackClick,
        onAudioChannelClick,
    } = props;
    
    const getAudioTrack = mapAudioTrack({
        onlyMonoAudioAvailable,
        frameRate,
        onAudioChannelClick,
        onAudioTrackClick,
    });
    
    return audioTracks.map(getAudioTrack);
};

export default function AudioTracks(props: AudioTracksProps) {
    const audioTracks = getAudioTracks(props);
    
    return (
        <div>
            {audioTracks}
        </div>
    );
}
